import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ExpoViewLayer from "../components/ExpoViewLayer";

const ExpoViewPage = () => {
    return (
        <MasterLayout>
            <ExpoViewLayer />
        </MasterLayout>
    );
};

export default ExpoViewPage;
